import React from 'react';
import { Button } from '../ui/button';
import { API } from './shared';

const HeroSection = () => {
  return (
    <section className="hero-section pt-32 pb-16" data-testid="hero-section">
      <div className="container-luxury text-center">
        <p className="overline mb-4 animate-fade-in-up">The Alliance for Predictive Intelligence & Growth</p>
        <h1 className="heading-display text-4xl sm:text-5xl lg:text-6xl text-[#0B1A2B] mb-6 max-w-4xl mx-auto animate-fade-in-up animation-delay-300" data-testid="hero-headline">
          Make your next growth decision with stronger evidence.
        </h1>
        
        <p className="body-large max-w-3xl mx-auto mb-12 animate-fade-in-up animation-delay-600">
          APIG helps leadership teams make high-stakes decisions with clarity and confidence, from validated insight to strategic action to measurable growth. One alliance, three integrated strengths.
        </p>

        <div className="hero-flow animate-fade-in-up animation-delay-600" data-testid="hero-infographic">
          <div className="hero-flow-inner">
            <div className="flow-node flow-node--muted">
              <span className="flow-node-label">Challenge<br />& Risk</span>
            </div>
            <div className="flow-arrow" aria-hidden="true"><span>&rarr;</span></div>
            <div className="flow-node flow-node--dark">
              <span className="flow-node-num">01</span>
              <span className="flow-node-title">Predictive<br />Intelligence</span>
              <span className="flow-node-action">Validate</span>
            </div>
            <div className="flow-arrow" aria-hidden="true"><span>&rarr;</span></div>
            <div className="flow-node flow-node--dark">
              <span className="flow-node-num">02</span>
              <span className="flow-node-title">Strategic<br />Positioning</span>
              <span className="flow-node-action">Design</span>
            </div>
            <div className="flow-arrow" aria-hidden="true"><span>&rarr;</span></div>
            <div className="flow-node flow-node--dark">
              <span className="flow-node-num">03</span>
              <span className="flow-node-title">Growth<br />Activation</span>
              <span className="flow-node-action">Activate</span>
            </div>
            <div className="flow-arrow" aria-hidden="true"><span>&rarr;</span></div>
            <div className="flow-node flow-node--outcome">
              <span className="flow-node-label">De-Risked<br />Growth</span>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-12 animate-fade-in-up animation-delay-600">
          <Button 
            className="btn-primary rounded-none px-8 py-4 text-sm"
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            data-testid="hero-cta-primary"
          >
            Submit Your Challenge
          </Button>
          <Button 
            variant="outline"
            className="btn-secondary rounded-none px-8 py-4 text-sm"
            onClick={() => document.getElementById('evidence')?.scrollIntoView({ behavior: 'smooth' })}
            data-testid="hero-cta-secondary"
          >
            See Case Evidence
          </Button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
